module.exports = __webpack_public_path__ + "img/logo_fleury.6bddb7e8.png";